const element = document.querySelector('.o-header');
const { scrollingElement } = document;
document.addEventListener('scroll', () => {
	element.toggleAttribute('data-scrolled', scrollingElement.scrollTop > 0);
}, {
	passive: true,
});
